import React from "react";
import { Grid } from "@material-ui/core";

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import AddIcon from '@mui/icons-material/Add';

import RangeView from "./range";
import { Range } from "../../../../plas/map/places/models";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default function Schedule({ name, day, copyRanges, copiedRanges, disable }) {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const showMenu = Boolean(anchorEl);
  const [rangeText, setRangeText] = React.useState(day.asText());
  const [showRanges, setShowRanges] = React.useState(false);

  const onChange = () => {
    setRangeText(day.asText())
  }

  const collapse = () => {
    setShowRanges(false)
  }

  const expand = () => {
    setShowRanges(true)
  }

  const pasteRanges = () => {
    day.ranges = []
    copiedRanges.forEach((copyRange) => {
      var copied = new Range()
      copied.startTime.fromMinutes(copyRange.startTime.toMinutes())
      copied.endTime.fromMinutes(copyRange.endTime.toMinutes())
      day.addRange(copied)
    })
    setRangeText(day.asText())
  }

  const deleteRange = (range) => {
    day.ranges = day.ranges.filter((item) => {return item !== range})
    if (day.ranges.length === 0)
      setShowRanges(false)
    setRangeText(day.asText())
  }

  const createRange = (start, end) => {
    let newRange = new Range();
    newRange.startTime.fromMinutes(start)
    newRange.endTime.fromMinutes(end)
    day.addRange(newRange)
    setShowRanges(true)
    setRangeText(day.asText())
  }

  const onAddNewRange = (event) => {
    if (day.ranges.length === 0) {
      createRange(660,780)
    } else {
      openMenu(event.currentTarget)
    }
  }

  const closeMenu = () => {
    setAnchorEl(null)
  }

  const openMenu = (anchor) => {
    setAnchorEl(anchor)
  }

  const getGaps = () => {
    var gaps = [];
   
    var before = -5;
    for (var index = 0; index < day.ranges.length; index++) {
      let currentRange = day.ranges[index]
      let currentStart = currentRange.startTime.toMinutes();
      if (currentStart - before > 10) {
        let newGap = new Range();
        newGap.startTime.fromMinutes(before + 5);
        newGap.endTime.fromMinutes(currentStart - 5);
        gaps.push(newGap);
      }
      before = currentRange.endTime.toMinutes();
      if (index === day.ranges.length-1) {
        if (1440 - before > 10) {
          let newGap = new Range();
          newGap.startTime.fromMinutes(before + 5);
          newGap.endTime.fromMinutes(1440);
          gaps.push(newGap);
        }
      }
    }
    
    return gaps;
  }  

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} style={{ textAlign: 'left'}}>
        <Grid container spacing={2}>
          <Grid item xs={'auto'}>
            <div><b style={{fontSize: '18px'}}>{name}</b></div>
            <span style={{color: 'darkgray'}}>{rangeText}</span>
          </Grid>
          <Grid item xs={true} style={{ textAlign: 'right'}}>
            <Tooltip title="Copiar horarios">
              <IconButton onClick={() => copyRanges(day.ranges)} disabled={disable}>
                <ContentCopyIcon/>
              </IconButton>
            </Tooltip>
            <Tooltip title="Pegar horarios">
              <span>
                <IconButton disabled={!copiedRanges || disable} onClick={pasteRanges} >
                  <ContentPasteIcon/>
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Agregar horario">
              <IconButton onClick={onAddNewRange} disabled={disable || (day.ranges.length > 0 && getGaps().length === 0) }> 
                <AddIcon/>
              </IconButton>
            </Tooltip>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={showMenu}
                onClose={closeMenu}
                disabled={disable}
                MenuListProps={{'aria-labelledby': 'basic-button'}}>
                { getGaps().map((rangeGap) => (
                  <MenuItem key={rangeGap.startTime.toMinutes()} onClick={() => { 
                    createRange(rangeGap.startTime.toMinutes(), rangeGap.endTime.toMinutes()); 
                    closeMenu(); 
                    }}>
                    Agregar entre {rangeGap.asText()}
                  </MenuItem>
              ))}
            </Menu>

            { showRanges ? (
                <Tooltip title="Ocultar detalles">
                  <IconButton onClick={collapse}>
                    <ArrowDropUpIcon/>
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Mostrar detalles">
                  <span>
                    <IconButton disabled={day.ranges.length === 0} onClick={expand}>
                      <ArrowDropDownIcon/>
                      </IconButton>
                  </span>
                </Tooltip>
              )
            }
          </Grid>
        </Grid>
      </Grid>
      { showRanges && day.ranges.map((range,index) => (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={true}>
                <RangeView range={range} otherRanges={day.ranges.filter((otherRange) => otherRange !== range)} onChange={onChange} disable={disable} />
              </Grid>
              <Grid item xs={'auto'}> 
                <Tooltip title="Borrar horario">
                  <IconButton style={{marginLeft: '16px'}} onClick={() => { deleteRange(range) }} disabled={disable}>
                    <DeleteOutlineIcon/>
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
      ))}

    </Grid>
  );
}
